import { PageHero, Overline } from "@/components/Bits";
import { SecuritySection } from "@/components/SecuritySection";
import { Reveal } from "@/components/Reveal";

const PRACTICES = [
  ["Encryption everywhere", "All traffic is served over HTTPS with TLS 1.2+. Sensitive data is encrypted in transit and at rest."],
  ["PCI-DSS payments", "Card payments are processed exclusively by Stripe, a PCI-DSS Level 1 certified provider. We never store card numbers."],
  ["SOC 2-aligned controls", "Our processes follow SOC 2 principles across security, availability, and confidentiality."],
  ["Least-privilege access", "Access to systems and data is restricted on a strict need-to-know basis and regularly reviewed."],
  ["Data minimization", "We collect only the information necessary to deliver our mission and honor your request."],
  ["Continuous monitoring", "Systems are monitored for anomalies, and dependencies are kept patched and current."],
];

export default function Security() {
  return (
    <>
      <PageHero
        label="Security & Compliance"
        title="Built to earn your"
        accent="trust."
        subtitle="Protecting your data and your generosity is foundational to everything we do. Here's how we keep information safe."
      />
      <section className="mx-auto max-w-7xl px-5 py-24 md:px-8 md:py-28">
        <Reveal><Overline>Our Practices</Overline></Reveal>
        <div className="mt-12 grid gap-6 md:grid-cols-2">
          {PRACTICES.map(([t, d], i) => (
            <Reveal key={t} delay={(i % 2) * 0.06}>
              <div className="h-full rounded-2xl border border-border bg-card p-8">
                <h3 className="font-heading text-xl font-semibold">{t}</h3>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground">{d}</p>
              </div>
            </Reveal>
          ))}
        </div>
      </section>
      <SecuritySection compact />
    </>
  );
}
